require('./downloadFileModal.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');

class DownloadFileModal extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleOnDownloadFirstOption = this.handleOnDownloadFirstOption.bind(this);
        this.handleOnDownloadSecondOption = this.handleOnDownloadSecondOption.bind(this);
    }

    handleOnDownloadFirstOption() {
        const { onToggleDownloadModal, firstOptionHandler } = this.props;

        firstOptionHandler();
        onToggleDownloadModal();
    }

    handleOnDownloadSecondOption() {
        const { onToggleDownloadModal, secondOptionHandler } = this.props;

        secondOptionHandler();
        onToggleDownloadModal();
    }

    render() {
        const { onToggleDownloadModal, title, mainMessage, isOpen, firstOptionText, secondOptionText } = this.props;

        return (
            <OKModal
                isOpen={isOpen}
                onCloseCallback={onToggleDownloadModal}
                title={title}
                description={mainMessage}
                footerType="action"
                primaryButtonText={firstOptionText}
                onPrimaryButtonClick={this.handleOnDownloadFirstOption}
                onSecondaryButtonClick={this.handleOnDownloadSecondOption}
                secondaryButtonText={secondOptionText}
            />
        )
    }
}

DownloadFileModal.propTypes = {
    isOpen: PropTypes.bool,
    onToggleDownloadModal: PropTypes.func.isRequired,
    title: PropTypes.string,
    mainMessage: PropTypes.string,
    buttonMessage: PropTypes.string,
    firstOptionHandler: PropTypes.func.isRequired,
    secondOptionHandler: PropTypes.func.isRequired,
    firstOptionText: PropTypes.string.isRequired,
    secondOptionText: PropTypes.string.isRequired
};

DownloadFileModal.defaultProps = {
    isOpen: false
};

module.exports = DownloadFileModal;
